<template>
    <div
        :class="{
            'auto-hide-nav': true,
            'auto-hide-nav--is-hidden': isHidden,
            'auto-hide-nav--top': top,
        }"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'AutoHideNav',
    props: {
        scrollDelta: {
            type: Number,
            default: 10,
        },
        scrollOffset: {
            type: Number,
            default: 150,
        },
        top: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            scrolling: false,
            isHidden: false,
            previousTop: 0,
        };
    },
    mounted() {
        if (!this.disabled) {
            window.addEventListener('scroll', this.checkNav);
        }
    },
    beforeDestroy() {
        if (!this.disabled) {
            window.removeEventListener('scroll', this.checkNav);
        }
    },
    methods: {
        checkNav() {
            if (this.scrolling) {
                return;
            }

            this.scrolling = true;

            if (!window.requestAnimationFrame) {
                setTimeout(this.autoHideNav, 250);
            } else {
                requestAnimationFrame(this.autoHideNav);
            }
        },
        autoHideNav() {
            const currentTop = window.pageYOffset;

            this.checkStickyNav(currentTop);
            this.previousTop = currentTop;
            this.scrolling = false;
        },
        checkStickyNav(currentTop) {
            // scrolling up
            if (this.previousTop - currentTop > this.scrollDelta) {
                this.isHidden = false;
                this.$emit('on-show');
            }

            // scrolling down
            if (currentTop - this.previousTop > this.scrollDelta && currentTop > this.scrollOffset) {
                this.isHidden = true;
                this.$emit('on-hide');
            }
        },
    },
};
</script>
